import { clientWindow } from "./dom";
import {
  THandlerParams,
  THandlerResults,
  HandlerName,
  TBaseResponse,
  AppRouterName,
  TAppRouterArguments,
  JoinAdTaskParams,
  PageControlActionName,
} from "@/shared";

export function inAppCall<T extends HandlerName>(
  method: T,
  params?: THandlerParams[T]
): Promise<TBaseResponse<THandlerResults[T]>> | null {
  if (!clientWindow?.flutter_inappwebview) {
    return null;
  }
  return clientWindow.flutter_inappwebview.callHandler(method, params);
}

/**
 * 获取用户全部信息
 */
export async function getSessionInfoAsync() {
  const res = await inAppCall<HandlerName.GetSessionInfo>(
    HandlerName.GetSessionInfo
  );
  if (clientWindow && res) {
    clientWindow.yoofinds = res?.result;
  }

  return res;
}

/**
 * 客户端通道方法 - 获取客户端信息
 * @returns 客户端信息
 */
export async function getClientInfoAsync() {
  const res = await inAppCall<HandlerName.GetClientInfo>(
    HandlerName.GetClientInfo
  );
  return res?.result;
}

/**
 * 客户端通道方法 - 获取token
 * @returns token
 */
export async function getTokenAsync() {
  const res = await inAppCall<HandlerName.GetToken>(HandlerName.GetToken);
  return res?.result;
}

/**
 * 客户端通道方法 - 获取用户信息
 * @returns 用户信息
 */
export async function getUserInfoAsync() {
  const res = await inAppCall<HandlerName.GetUserInfo>(HandlerName.GetUserInfo);
  return res?.result;
}

/**
 * 客户端通道方法 - 获取用户uid
 * @returns 用户uid
 */
export async function getUidAsync() {
  const res = await inAppCall<HandlerName.GetUserInfo>(HandlerName.GetUserInfo);
  return res?.result?.uid;
}

export async function getSampleAuthorizeTTLinkAsync(link: string) {
  const res = await inAppCall<HandlerName.OpenSampleAuthorize>(
    HandlerName.OpenSampleAuthorize,
    link
  );
  return res;
}

export async function getGoAppUrlAsync<T extends AppRouterName>(
  routerName: T,
  args?: TAppRouterArguments[T]
) {
  const res = await inAppCall<HandlerName.ToNamed>(HandlerName.ToNamed, {
    routerName,
    arguments: args,
  });
  return res;
}

export async function joinAdTaskAsync(taskInfo: JoinAdTaskParams) {
  const res = await inAppCall<HandlerName.JoinAdTask>(
    HandlerName.JoinAdTask,
    taskInfo
  );
  return res;
}

export async function loginAsync(middleContent?: string) {
  const res = await inAppCall<HandlerName.Login>(HandlerName.Login, {
    middle_content: middleContent,
  });
  return res;
}

export async function setAppTitleAsync(title: string) {
  const res = await inAppCall<HandlerName.WebViewControl>(
    HandlerName.WebViewControl,
    {
      actionName: "setTitle",
      title,
    }
  );
  return res;
}

export async function setAppGoBackControlAsync() {
  const res = await inAppCall<HandlerName.WebViewControl>(
    HandlerName.WebViewControl,
    {
      actionName: "setBackModeToStack",
    }
  );
  return res;
}

export async function goBackAdTaskReloadAsync(url: string) {
  const res = await inAppCall<HandlerName.GoBackAdTaskReload>(
    HandlerName.GoBackAdTaskReload,
    url
  );
  return res;
}

export async function openWithNewWebViewAsync(url: string) {
  const res = await inAppCall<HandlerName.OpenWithNewWebView>(
    HandlerName.OpenWithNewWebView,
    {
      jump_url: url,
    }
  );
  return res;
}

export async function pageControlAsync(actionName: PageControlActionName) {
  const res = await inAppCall<HandlerName.PageControl>(
    HandlerName.PageControl,
    {
      actionName,
    }
  );
  return res;
}

export async function hideTitleBarAsync() {
  const res = await inAppCall<HandlerName.WebViewControl>(
    HandlerName.WebViewControl,
    {
      actionName: "hideTitleBar",
    }
  );
  return res;
}

export async function openMashupSelectScriptAsync(
  hash_id: string,
  product_id: string,
  ad_task_id?: string
) {
  const res = await inAppCall<HandlerName.ToNamed>(HandlerName.ToNamed, {
    routerName: AppRouterName.MashupSelectScript,
    arguments: {
      hash_id,
      product_id,
      ad_task_id,
    },
  });
  return res;
}
